import React from 'react';
import './focus.css';
import { FiCpu, FiDatabase, FiShare2, FiShield } from 'react-icons/fi';
import { focusAreas, approach } from '../../data/focus';

const icons = {
  brain: <FiCpu />,
  db: <FiDatabase />,
  network: <FiShare2 />,
  shield: <FiShield />,
};

const Focus = () => (
  <section id="focus">
    <div className="container">
      <div className="section__head reveal">
        <span className="section__eyebrow">02 — Focus</span>
        <div className="section__title">
          <h2>What I build</h2>
        </div>
        <p className="section__lead">
          Four problem shapes I get hired for — and the parts of each that usually decide whether
          the system holds up once it is live.
        </p>
      </div>

      <div className="focus__grid">
        {focusAreas.map((area, i) => (
          <article
            key={area.id}
            className="card focus__card reveal"
            style={{ transitionDelay: `${i * 90}ms` }}
          >
            <div className="focus__card-top">
              <span className="focus__icon">{icons[area.icon]}</span>
              <span className="focus__index mono">{area.index}</span>
            </div>

            <h3>{area.title}</h3>
            <p>{area.body}</p>

            <ul className="focus__tags">
              {area.tags.map((tag) => (
                <li key={tag} className="tag">
                  {tag}
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>

      <div className="focus__approach reveal">
        <h3 className="focus__approach-title">How the work actually runs</h3>
        <ol className="focus__steps">
          {approach.map((item, i) => (
            <li key={item.step} className="focus__step">
              <span className="focus__step-num mono">{String(i + 1).padStart(2, '0')}</span>
              <h4>{item.step}</h4>
              <p>{item.text}</p>
            </li>
          ))}
        </ol>
      </div>
    </div>
  </section>
);

export default Focus;
